import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { Box } from "@mui/material";

export default function RequirePermission({ permission, children }) {
  const token = localStorage.getItem("accessToken");
  if (!token) return <Navigate to="/auth/login" />;

  try {
    const decoded = jwtDecode(token);

    const keys = permission || []
    const permMap = decoded.permissions || {};

    const permOK =
      keys.length === 0 || keys.some((k) => permMap?.[k] === true);

    if (permOK) {
      return children;
    }

    return <Box p={2}>คุณไม่มีสิทธิ์เข้าถึงหน้านี้</Box>;
  } catch (e) {
    console.error("Token decode error:", e);
    return <Navigate to="/auth/login" />;
  }
}
